import * as actionTypes from './actionTypes';
import { PROGRESSIVE_PLANS_SUCCESS, PERKS_MODAL_DETAILS_SUCCESS } from '../../../../pages/ProgressivePlans/@Redux/actionTypes';

export const initialPerksAndServicesState = {
  addonsData: null,
  apiStatus: null,
  error: null,
  isPrefetched: false, // Track if data was prefetched from another page
  plansResponse: null, // Store progressive plans response for perks and badges
  perkDetails: null, // Store perk modal details
  stickyFooterHeight: 0, // Height of sticky footer for spacer padding calculation
};

function perksAndServicesReducer(state = initialPerksAndServicesState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PERKS_ADDONS_DATA: {
      const nextState = {
        ...state,
        apiStatus: 'IN_PROGRESS',
        error: null,
      };

      if (action.payload?.isPrefetch !== undefined) {
        nextState.isPrefetched = Boolean(action.payload.isPrefetch);
      }

      return nextState;
    }
    case actionTypes.FETCH_PERKS_ADDONS_DATA_SUCCESS:
      return {
        ...state,
        addonsData: action.payload.data,
        apiStatus: 'SUCCESS',
        error: null,
      };
    case actionTypes.FETCH_PERKS_ADDONS_DATA_FAILURE:
      return {
        ...state,
        apiStatus: 'FAILURE',
        error: action.error,
        isPrefetched: false, // Reset flag on failure
      };
    case actionTypes.RESET_PREFETCH_FLAG:
      return {
        ...state,
        isPrefetched: false,
      };
    case PROGRESSIVE_PLANS_SUCCESS:
      return {
        ...state,
        plansResponse: action.response,
      };
    case PERKS_MODAL_DETAILS_SUCCESS:
      return {
        ...state,
        perkDetails: action.response,
      };
    case actionTypes.SET_STICKY_FOOTER_HEIGHT:
      return {
        ...state,
        stickyFooterHeight: action.payload,
      };
    case actionTypes.RESET_PERKS_AND_SERVICES:
      return { ...initialPerksAndServicesState };
    default:
      return state;
  }
}

export default perksAndServicesReducer;
